import { render, staticRenderFns } from "./myTraining.vue?vue&type=template&id=054f4a48&scoped=true"
import script from "./myTraining.vue?vue&type=script&lang=js"
export * from "./myTraining.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054f4a48",
  null
  
)

export default component.exports